import store from "../controller/baseController";
import Enums from "../enums/enums";
import i18n from "../locales/i18n";

function GetMerchantPackageRightApplication(applicationRaw) {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(revenueRaw) {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(expenseRaw) {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(financeRaw) {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw) {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(documentRaw) {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(userRaw) {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(accountingPolicyRaw) {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(settingRaw) {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(accountRaw) {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw) {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw) {
  return { totalAsset: assetRaw.totalAsset };
}
function GetMerchantPackageRight(merchantPackageRightRaw) {
  if (merchantPackageRightRaw) {
    return {
      totalUserId: merchantPackageRightRaw ? merchantPackageRightRaw.totalUserId : 0,
      application: GetMerchantPackageRightApplication(merchantPackageRightRaw.application),
      account: GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account),
      tax: GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax),
      asset: GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset),
    };
  } else {
    return {
      totalUserId: 0,
      application: null,
      account: null,
      tax: null,
      asset: null,
    };
  }
}
function GetRole(userRoleRaw) {
  return {
    authorityRole: userRoleRaw.authorityRole,
    role: userRoleRaw.role,
    manageUser: userRoleRaw.manageUser,
    manageFinance: userRoleRaw.manageFinance,
    isSuperUser: userRoleRaw.isSuperUser,
    isUsePayroll: userRoleRaw.isUsePayroll,
    isUsePeakBoard: userRoleRaw.isUsePeakBoard,
    manageProduct: userRoleRaw.manageProduct,
    isSeeSelfDocuments: userRoleRaw.isSeeSelfDocuments,
    manageFinanceAndJournals: userRoleRaw.manageFinanceAndJournals,
    manageAsset: userRoleRaw.manageAsset,
    manageContact: userRoleRaw.manageContact,
    isViewReport: userRoleRaw.isViewReport,
  };
}
function GetSelectedMerchant(merchantRaw) {
  return {
    merchantId: merchantRaw.merchantId,
    businessCategoryId: merchantRaw.businessCategoryId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
    role: GetRole(merchantRaw.role),
  };
}
export default {
  GetSelectedMerchant(merchant) {
    return GetSelectedMerchant(merchant);
  },
  ConvertToUserModel(userInfo) {
    /* eslint-disable @typescript-eslint/camelcase */
    const userModel = {
      userId: userInfo.id,
      displayName: userInfo.given_name,
      lastLogInDateTime: userInfo.lastLogInDateTime,
      registerDateTime: userInfo.registerDateTime,
      phone: userInfo.phone_number,
      pictureUrl: userInfo.picture,
      signatureUrl: userInfo.signatureUrl,
      userEmail: userInfo.userEmail,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      birthdate: userInfo.birthdate,
      departmentId: userInfo.departmentId,
      departmentOther: userInfo.departmentOther,
      positionId: userInfo.positionId,
      positionOther: userInfo.positionOther,
      accountingFirmId: userInfo.accountingFirmId,
    };

    return userModel;
  },
  IsMerchantAFP() {
    const currentMerchant = store.getters.GetMerchant;
    return currentMerchant.isAccountingFirm;
  },
  CheckMerchantPackage(validPackageList) {
    const currentMerchant = store.getters.GetMerchant;
    const packageId = currentMerchant.package;
    if (validPackageList.includes(packageId)) {
      return true;
    }
    return false;
  },
  CheckMerchantAFPPackage() {
    return this.CheckMerchantPackage([Enums.Package.AFPFree, Enums.Package.AFPLedger, Enums.Package.AFPAccountant]);
  },
  GetBusinessType() {
    const typeId = store.getters.GetContactDetail.merchantType;
    let typeName = "-";
    switch (typeId) {
      case 1:
        typeName = i18n.t("Limited_Partnership");
        break;
      case 2:
        typeName = i18n.t("Company_Limited");
        break;
      case 3:
        typeName = i18n.t("Public_Company_Limited");
        break;
      case 4:
        typeName = i18n.t("Shop");
        break;
      case 5:
        typeName = i18n.t("Human");
        break;
      case 6:
        typeName = i18n.t("Body_of_Persons");
        break;
      case 7:
        typeName = i18n.t("Others");
        break;
      case 8:
        typeName = i18n.t("Ordinary_Partnership");
        break;
      case 9:
        typeName = i18n.t("Foundation");
        break;
      case 10:
        typeName = i18n.t("Association");
        break;
      case 11:
        typeName = i18n.t("Joint_Venture");
        break;
    }
    return typeName;
  },
  GetUserTemplate(userModel) {
    const userTemplate = {
      id: userModel.userId,
      pictureImg: {
        croppa: {},
        fileName: "",
        fileType: "",
        rawString: "",
        urlImg: userModel.pictureUrl,
      },
      isUpdatePictureImg: false,
      signatureImg: {
        croppa: {},
        fileName: "",
        fileType: "",
        rawString: "",
        urlImg: userModel.signatureUrl,
      },
      isUpdateSignatureImg: false,
      firstName: {
        value: userModel.firstName,
        validateError: false,
      },
      lastName: {
        value: userModel.lastName,
        validateError: false,
      },
      phone: {
        value: userModel.phone,
        validateError: false,
      },
      userEmail: {
        value: userModel.userEmail,
        validateError: false,
      },
      birthdate: {
        value: userModel.birthdate,
        validateError: false,
      },
      department: {
        value: { value: userModel.departmentId !== null ? userModel.departmentId : -1 },
        validateError: false,
      },
      departmentOther: {
        value: userModel.departmentOther ? userModel.departmentOther : "",
        validateError: false,
      },
      position: {
        value: { value: userModel.positionId !== null ? userModel.positionId : -1 },
        validateError: false,
      },
      positionOther: {
        value: userModel.positionOther ? userModel.positionOther : "",
        validateError: false,
      },
    };
    return userTemplate;
  },
};
